import React, { useState } from 'react';
import styles from './AddAITicketModal.module.css';

const AddAITicketModal = ({ isOpen, onClose }) => {
  const [content, setContent] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!content.trim()) {
      alert('Bitte geben Sie Inhalt ein');
      return;
    }

    setIsSubmitting(true);
    try {
      const oneLinerContent = content.replace(/\n/g, ' ').replace(/\r/g, ' ');

      const response = await fetch(`https://wsticket.frozentoasty.de/api/webhook/email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          emailContent: oneLinerContent
        }),
      });

      if (response.ok) {
        setContent('');
        onClose();
      } else {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
        console.error('Server error response:', errorData);
        alert(`Server-Fehler (${response.status}): ${errorData.error || 'Unbekannter Fehler'}`);
      }
    } catch (error) {
      console.error('Request error:', error);
      alert(`Fehler: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setContent('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>AI Ticket erstellen</h2>
          <button className={styles.closeButton} onClick={handleClose}>
            ×
          </button>
        </div>
        
        <div className={styles.modalBody}>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Email-Inhalt hier einfügen..."
            className={styles.contentInput}
            rows={10}
            disabled={isSubmitting}
          />
        </div>
        
        <div className={styles.modalFooter}>
          <button 
            className={styles.cancelButton} 
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Abbrechen
          </button>
          <button 
            className={styles.createButton} 
            onClick={handleSubmit}
            disabled={isSubmitting || !content.trim()}
          >
            {isSubmitting ? 'Erstelle...' : 'Erstellen'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAITicketModal;